import "./partnersinfo.css";
import nvidiaInception from '../../../assets/images/nvidia-inception.png';
import wwyk from '../../../assets/images/WWYK.png';
import exequantum from '../../../assets/images/exequantum.png';
import rstcloud from '../../../assets/images/rstcloud.png';
import make from '../../../assets/images/make.png';

const PartnersInfo = (props) => {
    return(
        <section className="partners_info">
            <div className="content_sec">
                <h2>Technology Partners</h2>
                <p>{props.para}</p>
                
                <div className="partners-distributor-container">
                    <div className="partners-distributor-item">
                        <div className="partners-distributor-item-content">
                            <img className="partners-distributor-centered-image" src={nvidiaInception} />
                            <a className="partners-distributor-button" href="https://www.nvidia.com/en-us/gpu-accelerated-applications/?search=sharepass" target="_blank">
                                Learn more
                            </a>
                        </div>
                    </div>
                    <div className="partners-distributor-item">
                        <div className="partners-distributor-item-content">
                            <img className="partners-distributor-centered-image" src={wwyk} />
                            <a className="partners-distributor-button" href="https://www.yubico.com/works-with-yubikey/catalog/SharePass/" target="_blank">
                                Learn more
                            </a>
                        </div>
                    </div>
                    <div className="partners-distributor-item">
                        <div className="partners-distributor-item-content">
                            <img className="partners-distributor-centered-image" src={exequantum} />
                            <a className="partners-distributor-button" href="https://www.exequantum.com/" target="_blank">
                                Learn more
                            </a>
                        </div>
                    </div>
                    <div className="partners-distributor-item">
                        <div className="partners-distributor-item-content">
                            <img className="partners-distributor-centered-image" src={rstcloud} />
                            <a className="partners-distributor-button" href="https://www.rstcloud.com/" target="_blank">
                                Learn more
                            </a>
                        </div>
                    </div>
                    <div className="partners-distributor-item">
                        <div className="partners-distributor-item-content">
                            <img className="partners-distributor-centered-image" src={make} />
                            <a className="partners-distributor-button" href="https://www.make.com/" target="_blank">
                                Learn more
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default PartnersInfo;